// extracted by mini-css-extract-plugin
export default {"list":"socials_list__15axw","footer":"socials_footer__EY3ia","listItem":"socials_listItem__65Om-","footerListItem":"socials_footerListItem__sBcnk"};